import { render, staticRenderFns } from "./Science-addPersonnel.vue?vue&type=template&id=79101f88&scoped=true&"
import script from "./Science-addPersonnel.vue?vue&type=script&lang=js&"
export * from "./Science-addPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./Science-addPersonnel.vue?vue&type=style&index=0&id=79101f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79101f88",
  null
  
)

export default component.exports